<template>
	<div>
		<j-base-multi-select-with-flexible-value
			@blur="$emit('blur')"
			@input="onInput"
			:options="computedCodes"
			:value="computedValue"
			:allowLocalSearch="true"
			:allowMultiselect="false"
			placeholder="Search description"
			nameKey="description"
		/>
	</div>
</template>

<script>
import JBaseMultiSelectWithFlexibleValue from "@/components/JBaseMultiSelectWithFlexibleValue"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { JBaseMultiSelectWithFlexibleValue },
	props: {
		value: {
			type: [Array, String]
		}
	},

	data() {
		return {
			codes: []
		}
	},

	computed: {
		computedValue() {
			const valueObj = this.value ? JSON.parse(this.value) : this.value
			const value = valueObj?.[0]?.value?.stringValue
			const description = valueObj?.[1]?.value?.stringValue

			return value ? [{ description, value }] : []
		},

		computedCodes() {
			return this.codes.map(item => ({
				...item,
				name: `${item.description} (${item.code})`
			}))
		}
	},

	methods: {
		onInput(value = []) {
			// Convert to scalarValues
			const output = [
				{ key: "value", value: { stringValue: value?.[0]?.value } },
				{ key: "description", value: { stringValue: value?.[0]?.description } },
				{ key: "code", value: { stringValue: value?.[0]?.code } },
				{
					key: "riskAppetite",
					value: { stringValue: value?.[0]?.riskAppetite }
				},
				{
					key: "riskHazardGrade",
					value: { numberValue: value?.[0]?.riskHazardGrade }
				}
			]

			this.$emit("input", JSON.stringify(output))
		},

		async fetchCodes() {
			// TODO: This is based on name of the code which is bit fragile
			// because if they change `name` it will not fetch proper templates
			// In future it should be based on `code` field that will be unique
			const query = gql`
				query getNAICcodes {
					templates(where: { type: "dynamic", name: "NAIC" }) {
						totalCount
						list {
							id
							name
							description
							... on dynamicTemplate {
								dynamicValues {
									valueId
									valueJsonString
								}
							}
						}
					}
				}
			`
			const res = await api({ query, variables: {} })
			this.codes =
				res?.data?.templates?.list?.[0]?.dynamicValues?.map(item => {
					return {
						value: item.valueId,
						...JSON.parse(item.valueJsonString)
					}
				}) || []
		}
	},

	mounted() {
		this.fetchCodes()
	}
}
</script>
